import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-602a1ba0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-evolution-vs-prev-period"
};
const _hoisted_2 = {
  class: "revenue-text"
};
const _hoisted_3 = {
  class: "evolution"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "vs LY", -1));
const _hoisted_6 = {
  class: "revenue-tooltip"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "revenue-tooltip-title"
}, "Revenue evolution (vs LY)", -1));
const _hoisted_8 = {
  class: "revenue-tooltip-footer"
};
const _hoisted_9 = {
  key: 0,
  class: "hovering-details"
};
const _hoisted_10 = {
  class: "label"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dashed-line"
}, null, -1));
const _hoisted_12 = ["id"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "vs PP", -1));
const _hoisted_14 = {
  class: "revenue-tooltip"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "revenue-tooltip-title"
}, "Revenue evolution (vs PP)", -1));
const _hoisted_16 = {
  class: "revenue-tooltip-footer"
};
const _hoisted_17 = {
  key: 0,
  class: "hovering-details"
};
const _hoisted_18 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_revenue_evolution_graph = _resolveComponent("revenue-evolution-graph");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_currency_value, {
    value: $props.revenueData[0]?.revenue,
    precision: "2"
  }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "evolution-content",
    id: `${$options.evolution_content_uid}_vs_LY`
  }, [_createVNode(_component_percentage_value, {
    value: $props.revenueData[0]?.revenue_evol_vs_last_year,
    showSymbol: true,
    precision: 1
  }, null, 8, ["value"]), _hoisted_5, _createVNode(_component_app_popover, {
    target: `${$options.evolution_content_uid}_vs_LY`,
    placement: "top",
    customClass: "revenue-evol-tooltip",
    delay: {
      show: 0,
      hide: 100
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_revenue_evolution_graph, {
      revenueData: $props.revenueData,
      maxValue: _ctx.maxValue,
      selected_period: $props.selected_period,
      isLastest: "",
      index: $props.revenueData.length - 1,
      hovering_index: $data.hovering_index,
      value_key: "revenue_evol_vs_last_year",
      onHoveringCandle: $options.hoveringCandle
    }, null, 8, ["revenueData", "maxValue", "selected_period", "index", "hovering_index", "onHoveringCandle"]), _createElementVNode("div", _hoisted_8, [$data.hovering_index >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_currency_value, {
      value: $props.revenueData[$data.hovering_index]?.revenue,
      precision: "2"
    }, null, 8, ["value"]), _createVNode(_component_percentage_value, {
      value: $props.revenueData[$data.hovering_index]?.revenue_evol_vs_last_year,
      showSymbol: true,
      precision: 1,
      style: _normalizeStyle({
        color: $props.revenueData[$data.hovering_index]?.revenue_evol_vs_last_year < 0 ? '#e7747a' : $props.revenueData[$data.hovering_index]?.revenue_evol_vs_last_year > 0 ? '#22863d' : '#757575'
      })
    }, null, 8, ["value", "style"]), _createElementVNode("div", _hoisted_10, _toDisplayString($props.revenueData[$data.hovering_index]?.label), 1)])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["target"])], 8, _hoisted_4), _hoisted_11, _createElementVNode("div", {
    class: _normalizeClass(["evolution-content prev-period", $options.computedEvolution]),
    id: `${$options.evolution_content_uid}_vs_PP`
  }, [_createVNode(_component_percentage_value, {
    value: $props.revenueData[0]?.revenue_evol_vs_previous_period,
    showSymbol: true,
    precision: 1
  }, null, 8, ["value"]), _hoisted_13, _createVNode(_component_app_popover, {
    target: `${$options.evolution_content_uid}_vs_PP`,
    placement: "top",
    customClass: "revenue-evol-tooltip",
    delay: {
      show: 0,
      hide: 100
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_revenue_evolution_graph, {
      revenueData: $props.revenueData,
      maxValue: _ctx.maxValue,
      selected_period: $props.selected_period,
      isLastest: "",
      index: $props.revenueData.length - 1,
      hovering_index: $data.hovering_index,
      value_key: "revenue_evol_vs_previous_period",
      onHoveringCandle: $options.hoveringCandle
    }, null, 8, ["revenueData", "maxValue", "selected_period", "index", "hovering_index", "onHoveringCandle"]), _createElementVNode("div", _hoisted_16, [$data.hovering_index >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_currency_value, {
      value: $props.revenueData[$data.hovering_index]?.revenue,
      precision: "2"
    }, null, 8, ["value"]), _createVNode(_component_percentage_value, {
      value: $props.revenueData[$data.hovering_index]?.revenue_evol_vs_previous_period,
      showSymbol: true,
      precision: 1,
      style: _normalizeStyle({
        color: $props.revenueData[$data.hovering_index]?.revenue_evol_vs_previous_period < 0 ? '#e7747a' : $props.revenueData[$data.hovering_index]?.revenue_evol_vs_previous_period > 0 ? '#22863d' : '#757575'
      })
    }, null, 8, ["value", "style"]), _createElementVNode("div", _hoisted_18, _toDisplayString($props.revenueData[$data.hovering_index]?.label), 1)])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["target"])], 10, _hoisted_12)])]);
}